const shot = (id) =>
  `https://fra.cloud.appwrite.io/v1/storage/buckets/685a7bd100084facdc95/files/${id}/view?project=685987e3000799209566&mode=admin`;

export const resumeUrl = `${process.env.PUBLIC_URL}/Ayush-Kumawat-Resume.pdf`;

export const profileImage = shot('6890c49600093780cbbd');

export const NAV = [
  { id: 'work', label: 'Work' },
  { id: 'experience', label: 'Experience' },
  { id: 'proof', label: 'Proof' },
  { id: 'dashboard', label: 'GitHub' },
  { id: 'contact', label: 'Contact' },
];

export const chapters = [
  { id: 'top', label: 'Start' },
  { id: 'work', label: 'Work' },
  { id: 'experience', label: 'Experience' },
  { id: 'proof', label: 'Proof' },
  { id: 'dashboard', label: 'GitHub' },
  { id: 'contact', label: 'Contact' },
];

export const socials = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/ayush-kumawat/' },
  { label: 'GitHub', href: 'https://github.com/Ayushkumawat' },
  { label: 'Email', href: 'mailto:ayushkumawat2112@gmail.com' },
  { label: 'X', href: 'https://twitter.com/_Ayush_Kumawat' },
];

export const roles = [
  'Perception, language, and agents.',
  'Generative systems that show their source.',
  'Models that still run when the link drops.',
  'The work between a notebook and a product.',
];

export const ribbon = [
  'Space',
  'EdTech',
  'Infrastructure',
  'Surveillance',
  'Generative AI',
  'Agents',
  'Computer vision',
  'Edge',
];

export const fields = [
  { id: 'isro', label: 'Space' },
  { id: 'tutor', label: 'EdTech' },
  { id: 'work', label: 'Infrastructure' },
  { id: 'proof', label: 'Surveillance' },
];

export const films = [
  {
    id: 'audit',
    file: 'road-audit.mp4',
    kicker: 'Computer vision',
    title: 'Road audit in 180° and 360°',
    place: 'AI UNIKA Technologies · Pune',
    text: 'High-resolution 180° and 360° video, processed to audit road infrastructure: asset inventory along the corridor, and checks for safety compliance.',
    tags: ['180° video', '360° video', 'Asset inventory', 'Safety compliance'],
  },
  {
    id: 'nhai',
    file: 'nhai-night.mp4',
    kicker: 'Computer vision · night',
    title: 'NHAI inspection after dark',
    place: 'National highways',
    text: 'Night detections on NHAI: reflectors, street lights that are out, and the other classes the inspection has to catch.',
    tags: ['Reflectors', 'Street lights', 'Night classes'],
  },
];

export const beats = [
  {
    id: 'habit',
    kicker: 'The habit',
    title: 'I like the moment a messy problem becomes a system.',
    text: 'Not the slide. The version that still behaves when the person who built it has left the room. I start optimistic on purpose. I assume there is a way through, then I go looking for the way it would fail.',
  },
  {
    id: 'origin',
    kicker: 'Where it started',
    title: 'Indore, a degree, and a trail of public experiments.',
    text: 'I studied data science and artificial intelligence at Sage University. I did not wait for a job title. Drones, number plates, a small medical tool, a bus system: I wanted software that could notice the world, and I put the attempts where anyone could read them.',
  },
  {
    id: 'bench',
    kicker: 'The turn',
    title: 'A lab that did not clap for the demo.',
    text: 'A season at ISRO in Ahmedabad. Telemetry, models that had to be compared, and a machine that reported its own heat and memory. In the same room I started tying language models to a source, so an answer could show where it came from. That is when “it works” became “I can defend it.”',
  },
  {
    id: 'now',
    kicker: 'Now',
    title: 'Two years in, and I still refuse a single lane.',
    text: 'Perception when the world is a signal. Language and agents when a person needs to ask, remember, and act. I am an AI and ML engineer, and generative work sits in that same practice. I follow the problem, then pick the method it can survive.',
  },
];

export const principles = [
  {
    id: 'hope',
    title: 'Hope, then pressure',
    text: 'I assume it can be done. Then I try to break it before a user does. Optimism is how I start. Measurement is how I keep the optimism honest.',
  },
  {
    id: 'number',
    title: 'A number I can defend',
    text: 'A screenshot is easy. A latency, an error I have looked at, and a fallback I have actually tried are what I want to stand next to.',
  },
  {
    id: 'alone',
    title: 'It should have a plan when I am gone',
    text: 'Weak networks, empty answers, a model that is unsure. The system should already know its next move, instead of waiting for me to notice.',
  },
  {
    id: 'person',
    title: 'Say it in their language',
    text: 'The person who lives with the system is rarely the person who trained it. I translate the model into the decision they actually have to make.',
  },
];

export const lenses = [
  {
    id: 'notice',
    title: 'Notice',
    text: 'Signals, images, and the errors hiding inside them.',
    items: ['PyTorch', 'OpenCV', 'Detection', 'Evaluation', 'Error analysis'],
  },
  {
    id: 'talk',
    title: 'Talk',
    text: 'Language that stays attached to a source.',
    items: ['RAG', 'LangChain', 'LangGraph', 'QLoRA', 'Hugging Face'],
  },
  {
    id: 'act',
    title: 'Act',
    text: 'Agents and services that take the next step, and know when to stop.',
    items: ['Tool use', 'FastAPI', 'WebSockets', 'Gemini Live', 'MLflow'],
  },
  {
    id: 'ship',
    title: 'Ship',
    text: 'The device, the cloud, and the screen a person actually touches.',
    items: ['Jetson', 'ONNX', 'TensorRT', 'Docker', 'React', 'AWS', 'GCP'],
  },
];

export const projects = [
  {
    id: 'dashcam',
    index: '01',
    tone: 'road',
    scene: 'Someone is driving. A hazard is in the frame for less than a second.',
    title: 'Road-hazard dashcam',
    bridge: '',
    summary:
      'On-device hazard detection for a moving vehicle, with the labeling tools and FastAPI services around the model.',
    facts: [
      { v: '18–20', k: 'Frames each second' },
      { v: '<30 ms', k: 'To make the call' },
      { v: '85%', k: 'Hazard detection' },
    ],
    stack: ['Detection', 'Segmentation', 'FastAPI', 'Edge'],
    meta: 'AI UNIKA Technologies · Pune · 2025',
  },
  {
    id: 'toll',
    index: '02',
    tone: 'net',
    scene: 'A state needed a traffic count it could stand behind, across hundreds of cameras.',
    title: 'Toll traffic count',
    bridge: '',
    summary:
      'Vehicle counting for a Maharashtra toll study. Feeds went to a VM when the link held, and to a Jetson on site when it did not.',
    facts: [
      { v: '561', k: 'Cameras' },
      { v: '89%', k: 'Counting accuracy' },
      { v: '24', k: 'People in the field' },
    ],
    stack: ['YOLO', 'ONNX', 'INT8', 'TensorRT', 'RTSP'],
    meta: 'Delphic Global · MSIDC · 2025',
  },
  {
    id: 'tutor',
    index: '03',
    tone: 'voice',
    scene: 'A student asks a question. The answer should come from their book, not from the open internet.',
    title: 'Curriculum tutor',
    bridge: '',
    summary:
      'A teaching assistant that retrieves from the textbook before it answers. Voice on top, a book-like screen in React.',
    facts: [
      { v: 'RAG', k: 'Grounded in the book' },
      { v: 'QLoRA', k: 'Tuned to the domain' },
      { v: 'Voice', k: 'A conversation, not a form' },
    ],
    stack: ['LangChain', 'FastAPI', 'React', 'Gemini Live'],
    meta: 'Generative AI · K–12',
  },
  {
    id: 'isro',
    index: '04',
    tone: 'orbit',
    scene: 'A fault should be caught beside the data, not after a round trip to somewhere else.',
    title: 'Telemetry fault detection',
    bridge: '',
    summary:
      'Compared convolutional nets, sequence models, and simpler baselines on spacecraft telemetry, and measured them on a Jetson AGX Orin.',
    facts: [
      { v: 'CNN', k: 'Patterns in the signal' },
      { v: 'LSTM', k: 'The sequence of it' },
      { v: 'Orin', k: 'Measured on device' },
    ],
    stack: ['PyTorch', 'Jetson', 'LangGraph', 'RAG'],
    meta: 'ISRO SAC · Ahmedabad · 2024',
  },
];

export const builds = [
  {
    id: 'drone',
    tag: 'Noticing',
    title: 'Aerial drone detection',
    summary: 'A model watches a zone and warns when a drone crosses into it.',
    href: 'https://github.com/Ayushkumawat/Advanced-Aerial-Drone-Detection-System',
    image: shot('686ba1cb001c899f5bb4'),
  },
  {
    id: 'plate',
    tag: 'Noticing',
    title: 'Number plate detection',
    summary: 'Live video in, a plate read out, each hit kept.',
    href: 'https://github.com/Ayushkumawat/Number-Plate-Detection-Advanced-using-Python',
    image: shot('686ba1d0002f8c5c5591'),
  },
  {
    id: 'med',
    tag: 'Health',
    title: 'AI Med Diagnosis',
    summary: 'Symptom tracking with an honest estimate of how likely a match is.',
    href: 'https://github.com/Ayushkumawat/AI-MedDiagnostics',
    image: shot('686ba1b8001419bdba66'),
  },
  {
    id: 'face',
    tag: 'Noticing',
    title: 'Facial recognition',
    summary: 'Recognises a person and estimates gender from one clear photograph.',
    href: 'https://github.com/Ayushkumawat/Facial-Recognition-with-Gender-Detection',
    image: shot('686ba1c600152894f8a4'),
  },
  {
    id: 'bus',
    tag: 'Systems',
    title: 'Bus passenger records',
    summary: 'QR tickets for local buses, with passenger rows the operator can keep.',
    href: 'https://github.com/Ayushkumawat/Bus-Passenger-Management-using-Smart-Card-Technology',
    image: shot('686ba1bf0003820c31c5'),
  },
  {
    id: 'table',
    tag: 'Voice',
    title: 'Voice table service',
    summary: 'Hands-free ordering for a restaurant table. Later published as a patent.',
    href: 'https://github.com/Ayushkumawat',
    image: shot('686ba1d70039960961b8'),
  },
];

export const jobs = [
  {
    id: 'unika',
    period: 'Sep 2025 to present',
    role: 'AI Engineer',
    org: 'AI UNIKA Technologies · Pune',
    points: [
      'Road vision: 180° and 360° infrastructure audit, and night inspection of reflectors and street lights.',
    ],
  },
  {
    id: 'delphic',
    period: 'Jan 2025 to Aug 2025',
    role: 'AI/ML Engineer',
    org: 'Delphic Global · Gurugram',
    points: [
      'Traffic count across 561 cameras in Maharashtra. On a Jetson when the link was weak, on a VM when it held. Field team of 24.',
    ],
  },
  {
    id: 'isro',
    period: 'Aug 2024 to Dec 2024',
    role: 'AI Researcher',
    org: 'ISRO SAC · Ahmedabad',
    points: [
      'Fault detection on spacecraft telemetry, measured on Jetson AGX Orin, plus retrieval and agent flows in the same lab.',
    ],
  },
  {
    id: 'google',
    period: 'Jan 2024 to Mar 2024',
    role: 'AI/ML Intern',
    org: 'Google for Developers',
    points: [
      'Image classification and detection aimed at real scenes, then deployed on Google Cloud.',
    ],
  },
  {
    id: 'acm',
    period: 'Jun 2023 to Jun 2024',
    role: 'Chairperson',
    org: 'ACM Student Chapter · Sage University',
    points: ['Ran the student chapter through the final year of the degree.'],
  },
  {
    id: 'personifwy',
    period: 'Aug 2022 to Nov 2022',
    role: 'Machine Learning Intern',
    org: 'Personifwy',
    points: ['Classified news with classical NLP, from a cleaned corpus through to the evaluation.'],
  },
];

export const proofs = [
  {
    id: 'patent-threat',
    title: 'Threat detection in surveillance',
    meta: 'Patent · 202421078621 · Journal 47/2024',
    text: 'An AI approach for fire, smoke, intruders, and unusual movement, without a stack of extra sensors.',
    image: shot('686ba3d6002e9926a400'),
  },
  {
    id: 'patent-voice',
    title: 'Voice-automated table service',
    meta: 'Patent · 202321013305 · Journal 11/2023',
    text: 'Speech in, an order out. The restaurant idea from the early builds, written up as a patent.',
    image: shot('686ba3d200199a49205f'),
  },
  {
    id: 'shrag',
    title: 'SH-RAG',
    meta: 'IET · Parul University ICET 2025',
    text: 'A self-healing retrieval setup. It retrieves, checks the claim, and revises the answer before it stands.',
  },
  {
    id: 'hackathon',
    title: 'Solving for India',
    meta: 'Google Cloud and AMD',
    text: 'Won the hackathon with a team entry across cloud and hardware.',
    image: shot('686ba3db00398593fbfc'),
  },
  {
    id: 'academic',
    title: 'Academic Excellence Award',
    meta: 'Sage University · B.Tech',
    text: 'Awarded across the degree. Graduated with CGPA 8.6 in data science and artificial intelligence.',
    image: shot('686ba3b100331caa8798'),
  },
];

export const certs = [
  {
    id: 'nvidia',
    title: 'Jetson AI Specialist',
    organization: 'NVIDIA',
    year: 'Edge AI',
    image: shot('686ba3cd002e16d56556'),
  },
  {
    id: 'isro-cert',
    title: 'AI Researcher',
    organization: 'ISRO SAC, Ahmedabad',
    year: '2024',
    image: shot('686ba2d7000a1bbba4eb'),
  },
  {
    id: 'ielts',
    title: 'IELTS Academic 7.5',
    organization: 'CEFR C1',
    year: '2024',
    image: shot('686ba304002a04a4501d'),
  },
  {
    id: 'ibm',
    title: 'Applied Data Science Capstone',
    organization: 'IBM',
    year: '2023',
    image: shot('686ba2dc000c85d0427f'),
  },
  {
    id: 'nptel',
    title: 'Programming and DSA',
    organization: 'NPTEL · Elite',
    year: '2023',
    image: shot('686ba30a00128a201136'),
  },
  {
    id: 'guvi',
    title: 'Full Stack Development',
    organization: 'GUVI',
    year: '2022',
    image: shot('686ba2fd000b88544fb4'),
  },
];

export const channels = [
  {
    id: 'email',
    label: 'Email',
    value: 'ayushkumawat2112@gmail.com',
    href: 'mailto:ayushkumawat2112@gmail.com',
  },
  {
    id: 'phone',
    label: 'Phone',
    value: '+91 90989 84098',
    href: 'tel:+919098984098',
  },
  {
    id: 'whatsapp',
    label: 'WhatsApp',
    value: 'Message on WhatsApp',
    href: 'https://wa.me/919098984098?text=Hello%20Ayush',
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    value: 'ayush-kumawat',
    href: 'https://www.linkedin.com/in/ayush-kumawat/',
  },
];

export const FORM_ENDPOINT =
  'https://docs.google.com/forms/d/e/1FAIpQLSc1G9vTsiEK1lAljrjXKv1RYqRCotJ0K1YvQ04wURPuRptd4g/formResponse';

export const FORM_FIELDS = {
  name: 'entry.1436918931',
  email: 'entry.115868657',
  subject: 'entry.1530612299',
  message: 'entry.499974809',
};
